<template>
  <router-view></router-view>
</template>
<script>

// Department Store registered in App.vue

export default {
  name: 'department',
  data() {
    return {};
  },
};
</script>
